import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import ProfileSideBar from '../components/ProfileSideBar';
import ProfileManager from '../components/ProfileManager';
import AccountSettings from '../components/AccountSettings';

// Shared look (design tokens) - same as the rest of IZHub
const ui = {
  primary: '#009db9',
  text: '#1f2933',
  muted: '#6b7280',
  border: '#e5e7eb',
  shadow: '0 4px 20px rgba(16, 24, 40, 0.06)',
};

const ProfilePage = () => {
  const [progress, setProgress] = useState(0);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        bgcolor: '#f4f7f9',
      }}
    >
      <Box
        sx={{
          maxWidth: '1200px',
          margin: '0 auto',
          width: '100%',
          boxSizing: 'border-box',
          px: { xs: 2, sm: 3, md: 4 },
          pt: { xs: 11, sm: 12, md: 14 },
          pb: 8,
          display: 'grid',
          gridTemplateColumns: { xs: 'minmax(0, 1fr)', lg: '320px minmax(0, 1fr)' },
          gap: { xs: 2.5, lg: 4 },
          alignItems: 'start',
        }}
      >
        {/* Sidebar: full profile card on desktop, compact header + menu on smaller screens */}
        <Box
          sx={{
            position: { lg: 'sticky' },
            top: { lg: 104 },
            maxHeight: { lg: 'calc(100vh - 120px)' },
            overflowY: { lg: 'auto' },
          }}
        >
          <ProfileSideBar progress={progress} />
        </Box>

        {/* Main Content */}
        <Box
          sx={{
            minWidth: 0,
            bgcolor: 'white',
            borderRadius: '20px',
            border: `1px solid ${ui.border}`,
            boxShadow: ui.shadow,
            p: { xs: 2.5, sm: 4 },
          }}
        >
          {/* Page header */}
          <Box sx={{ mb: { xs: 3.5, sm: 4.5 } }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 'bold',
                color: ui.text,
                letterSpacing: 0.5,
                fontSize: { xs: '1.5rem', sm: '1.85rem', md: '2.125rem' },
                position: 'relative',
                '&::after': {
                  content: '""',
                  display: 'block',
                  backgroundColor: ui.primary,
                  height: '4px',
                  width: { xs: '80px', sm: '100px' },
                  position: 'absolute',
                  left: 0,
                  bottom: '-8px',
                },
              }}
            >
              My Profile
            </Typography>
            <Typography sx={{ color: ui.muted, mt: 2.5, fontSize: { xs: '0.9rem', sm: '1rem' } }}>
              Manage your personal details, skills, credentials and account settings.
            </Typography>
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
            }}
          >
            {/* ProfileManager handles UserProfile, Skills, Language, Certificate, Diploma */}
            <ProfileManager setProgress={setProgress} />
            {/* AccountSettings is separate */}
            <Box
              id="profile-section-account"
              sx={{ scrollMarginTop: { xs: '100px', md: '120px' } }}
            >
              <AccountSettings />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ProfilePage;